import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";

export function MarketingNav() {
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="global-nav-home">
          <Logo />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <ThemeToggle />
          <Link to="/showcase" data-testid="global-nav-showcase">
            <Button variant="ghost" className="rounded-sm font-mono text-xs uppercase tracking-widest">
              Showcase
            </Button>
          </Link>
          <Link to="/pricing" data-testid="global-nav-pricing">
            <Button variant="ghost" className="rounded-sm font-mono text-xs uppercase tracking-widest">
              Pricing
            </Button>
          </Link>
          <Link to="/use-cases" data-testid="global-nav-link">
            <Button variant="ghost" className="rounded-sm font-mono text-xs uppercase tracking-widest">
              Use&nbsp;Cases
            </Button>
          </Link>
          <Link to="/login">
            <Button variant="ghost" data-testid="nav-login-button" className="rounded-sm">
              Sign in
            </Button>
          </Link>
          <Link to="/register">
            <Button data-testid="nav-signup-button" className="rounded-sm">
              Begin
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function MarketingFooter() {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-4 px-6 py-10 sm:flex-row sm:items-center">
        <div className="flex items-center gap-3">
          <Logo showText size={16} />
        </div>
        <div className="text-right">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
            Espresso · Knowledge Processor · by Mahakali Studios
          </div>
          <div className="mt-1 font-display text-sm text-foreground" data-testid="footer-tagline">
            Ingest. Structure. Process. Publish.
          </div>
        </div>
      </div>
    </footer>
  );
}

// Processor pipeline bar: [01] Ingest → [02] Structure → [03] Process → [04] Publish
export function PipelineBar({ steps, testid = "pipeline-visualization" }) {
  return (
    <div
      className="flex flex-wrap items-stretch gap-px overflow-hidden rounded-md border border-border/70 bg-border/40"
      data-testid={testid}
    >
      {steps.map((s, i) => (
        <div
          key={s + i}
          className="group relative flex min-w-[130px] flex-1 flex-col gap-1.5 bg-card px-4 py-3.5 transition-colors hover:bg-secondary"
        >
          <div className="flex items-center gap-2">
            <span className="font-mono text-[10px] tracking-widest text-primary">
              {String(i + 1).padStart(2, "0")}
            </span>
            {i < steps.length - 1 && (
              <span className="h-px flex-1 bg-gradient-to-r from-accent/60 to-transparent" />
            )}
          </div>
          <span className="font-display text-sm font-medium leading-tight tracking-tight">{s}</span>
        </div>
      ))}
    </div>
  );
}
